import React from 'react';
import { usePayorListTableInit } from './usePayorListTableInit';
import { usePayorListTableState } from './usePayorListTableState';
import { usePayorData } from './usePayorData';
import TableTop from '../../../../core/table/TableTop';
import TableHead from '../../../../core/table/TableHead';
import { usePayorListStore } from '../pagehooks/usePayorListStore';
import TableBody from '../../../../core/table/TableBody';
import TablePaging from '../../../../core/table/TablePaging';
import payorRepo from '../../data/payorRepo';
import SaveToExcelButton from '../../../../core/table/actions/SaveToExcelButton';
import TableCreateEntityButton from '../../../../core/table/TableCreateEntityButton';
import TableList from '../../../../core/table/TableList';
import { ngDelegate } from '../../../../core/services/ng.delegate';
import { HttpErrorIgnore } from '../../../../../global';
import PayorImportFlyOut from '../import/PayorImportFlyOut';
import { usePayorListImport } from '../import/usePayorListImport';
import Button from '../../../../core/components/Button';

export const payorListTableId = 'adminPayorList';
const FILE_NAME = 'Verity-ExcludedPayorList';

const onGetExcel = (): Promise<HttpErrorIgnore | undefined> => payorRepo.getExcel(FILE_NAME);

const PayorListTable = (): JSX.Element => {
    const { init } = usePayorListTableInit();

    return init ? <></> : <TableWrapper />;
};

const TableWrapper = (): JSX.Element => {
    const { canEdit, routeToCreate, routeToEdit } = usePayorListStore();
    const { waiting, fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging, setWait } =
        usePayorListTableState();
    const { items } = usePayorData();
    const { showImport } = usePayorListImport();

    if (waiting) {
        ngDelegate.wait(true, true);
        return <></>;
    } else {
        ngDelegate.wait(false, true);
    }

    return (
        <TableList>
            <PayorImportFlyOut />
            <TableTop
                id={payorListTableId}
                fltStats={fltStats}
                topRight={
                    <>
                        <SaveToExcelButton
                            waiting={waiting}
                            setWait={setWait}
                            onGetExcel={onGetExcel}
                        />
                        {canEdit ? <Button onClick={showImport}>Import</Button> : null}
                        {canEdit ? (
                            <TableCreateEntityButton
                                id="adminPayorSearch"
                                onClick={routeToCreate}
                            />
                        ) : null}
                    </>
                }
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                    onClick={routeToEdit}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default PayorListTable;
